var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "table table-sm table-hover mt-0" }, [
    _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { staticClass: "w_m_200" }, [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", { staticClass: "w_m_400" }),
        _vm._v(" "),
        _c("th", [_vm._v("задачи")]),
        _vm._v(" "),
        _c("th", { class: { active: _vm.activeSorting === "call" } }, [
          !_vm.options?.disable?.sorting
            ? _c("i", {
                class: {
                  "icon-fa pointer": true,
                  "icon-fa-sort-amount-asc":
                    _vm.sorting.call.direction === "asc",
                  "icon-fa-sort-amount-desc":
                    _vm.sorting.call.direction !== "asc",
                },
                on: {
                  click: function ($event) {
                    return _vm.sortRecords("call")
                  },
                },
              })
            : _vm._e(),
          _vm._v("\n      Спрос\n    "),
        ]),
        _vm._v(" "),
        _c("th", { class: { active: _vm.activeSorting === "price" } }, [
          !_vm.options?.disable?.sorting
            ? _c("i", {
                class: {
                  "icon-fa pointer": true,
                  "icon-fa-sort-amount-asc":
                    _vm.sorting.price.direction === "asc",
                  "icon-fa-sort-amount-desc":
                    _vm.sorting.price.direction !== "asc",
                },
                on: {
                  click: function ($event) {
                    return _vm.sortRecords("price")
                  },
                },
              })
            : _vm._e(),
          _vm._v("\n      Ср. цена\n    "),
        ]),
        _vm._v(" "),
        _c("th", { class: { active: _vm.activeSorting === "potential" } }, [
          !_vm.options?.disable?.sorting
            ? _c("i", {
                class: {
                  "icon-fa pointer": true,
                  "icon-fa-sort-amount-asc":
                    _vm.sorting.potential.direction === "asc",
                  "icon-fa-sort-amount-desc":
                    _vm.sorting.potential.direction !== "asc",
                },
                on: {
                  click: function ($event) {
                    return _vm.sortRecords("potential")
                  },
                },
              })
            : _vm._e(),
          _vm._v("\n      Потенциал\n    "),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("Наличие")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.$currentListOfRecords, function (r, i) {
        return r
          ? _c("tr", { key: r.stats_record_id }, [
              _c("td", [
                _vm._v(
                  _vm._s(
                    i +
                      1 +
                      (_vm.paginator
                        ? (_vm.paginator.current_page - 1) *
                          _vm.paginator.per_page
                        : 0)
                  )
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("p", [_vm._v(_vm._s(r?.drug?.title || r.id))]),
                _vm._v(" "),
                r?.drug
                  ? _c("p", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(r?.drug?.group)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                (r?.statuses ?? []).length
                  ? _c("p", [
                      _c("span", { staticClass: "badge badge-info" }, [
                        _vm._v("скрыт"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "comment_div",
                  domProps: { innerHTML: _vm._s(_vm.getRecordComment(r)) },
                }),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  (r.all_tasks ?? []).length
                    ? [
                        _vm.options?.show?.taskResult
                          ? _c(
                              "div",
                              { staticClass: "flex flex_gap_10" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "align-self-center" },
                                  [
                                    _c("LoadingButton", {
                                      attrs: {
                                        title: "Возобновить",
                                        className: "btn btn-outline-success",
                                        onClick: () =>
                                          _vm.refreshTasks(
                                            r.id,
                                            r.all_tasks.map((t) => t.id)
                                          ),
                                        loading:
                                          _vm.loadingObject.btn.refreshTask[
                                            r.id
                                          ],
                                        type: "button",
                                        color: _vm.$constants.SUCCESS_COLOR,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("TaskResult", {
                                  attrs: {
                                    activeRecord: r,
                                    tasks: r.drug.scan_tasks,
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c("ScanFilters", {
                                  attrs: { records: r.drug.scan_tasks },
                                }),
                              ],
                              1
                            ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm._l(r?.drug?.related_drugs ?? [], function (d) {
                    return d?.drug?.id
                      ? _c("div", { staticClass: "flex align-items-center" }, [
                          _c("i", {
                            staticClass:
                              "icon-fa icon-fa-edit mr-2 openEditDrugIcon",
                            on: {
                              click: function ($event) {
                                return _vm.openDrugEdit(d.drug.id)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(d.drug.title))]),
                        ])
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  false &&
                  !(r?.drug?.related_drugs ?? []).length &&
                  !(r.drug?.tasks ?? []).find((t) => t.type_id === 27)
                    ? _c("LoadingButton", {
                        attrs: {
                          title: "задача привязать препараты РК",
                          loading: _vm.loadingObject.newPairTaskBtn[r.drug_id],
                          color: _vm.$constants.SUCCESS_COLOR,
                          onClick: () => _vm.createTask(r.drug_id, "pairDrug"),
                          className: "btn btn-xs btn-outline-success",
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "td",
                _vm._l(r?.drug?.tasks ?? [], function (t) {
                  return _c(
                    "div",
                    { staticClass: "mb-1" },
                    [
                      t.type_id === 22
                        ? [
                            _c("OutsorceCallTask", {
                              attrs: { task: t, record: r },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(r.call))]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "flex flex_gap_10 align-items-center" },
                  [
                    _c("LoadStoreTrendData", {
                      attrs: { type: "price", record: r },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(r.price))]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    Math.round(r.potential / 1000).toLocaleString("ru-RU")
                  ) + "k"
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "flex flex_gap_10 align-items-center" },
                  [
                    _c("LoadStoreTrendData", {
                      attrs: {
                        type: "store",
                        trend: +r.store_trend,
                        record: r,
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(r.stores))]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.printDate(r.created_at, "DD.MM.YYYY")) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "flex flex-nowrap" },
                  [
                    !(r.all_tasks ?? []).length && !r.statuses.length
                      ? void 0
                      : [
                          r.statuses.length
                            ? _c("LoadingButton", {
                                attrs: {
                                  title: r.statuses.length
                                    ? `<i class='icon-fa icon-fa-power-off'/>`
                                    : "Скрыть",
                                  type: "button",
                                  loading:
                                    _vm.loadingObject.drugBtnLoading[r.drug.id],
                                  color: _vm.$constants.LOADING_COLOR,
                                  onClick: () =>
                                    _vm.updateVisibility(
                                      r.drug.id,
                                      !!!r.statuses.length
                                    ),
                                  className: "btn btn-outline-info",
                                },
                              })
                            : _vm._e(),
                        ],
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.newTaskModal(r)
                          },
                        },
                      },
                      [_c("i", { staticClass: "icon-fa icon-fa-edit" })]
                    ),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e()
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }